/* Recent Activity (simple increment per interval)
 * Scoped IIFE with no globals. Reads simplified config from data attributes
 * rendered by Liquid inside the cart-drawer snippet.
 */
(function () {
  'use strict';
  var log = function() {};

  // Keep active state so we can rebind after DOM replacements
  var activeBanner = null;
  var activeTimer = null;
  var currentTick = null;
  var currentCatchUp = null;
  var lastCount = null;

  // Helpers for localStorage persistence
  function ymd(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1; if (m < 10) m = '0' + m;
    var d = date.getDate(); if (d < 10) d = '0' + d;
    return y + '-' + m + '-' + d;
  }
  function lsGet(key) { try { return window.localStorage ? window.localStorage.getItem(key) : null; } catch (e) { return null; } }
  function lsSet(key, val) { try { if (window.localStorage) window.localStorage.setItem(key, String(val)); } catch (e) {} }

  function init(banner) {
    // Clear previous timer if any and set current banner
    if (activeTimer) { try { clearInterval(activeTimer); } catch (e) {} activeTimer = null; }
    activeBanner = banner;
    var cfgNode = banner.querySelector('[data-ra-config]');
    var countNode = banner.querySelector('[data-ra-count]');
    if (!cfgNode || !countNode) { log('Missing cfg/count node', { cfgNode: !!cfgNode, countNode: !!countNode }); return; }
    function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }
    function toInt(val, fallback) {
      var n = parseInt(val, 10);
      return isNaN(n) ? fallback : n;
    }

    // Read simplified config
    var resetHour = toInt(cfgNode.getAttribute('data-ra-reset-hour'), 0);
    var base = toInt(cfgNode.getAttribute('data-ra-base'), 80);
    var intervalMin = clamp(toInt(cfgNode.getAttribute('data-ra-interval-min'), 5), 1, 60);
    var incPerUpdate = toInt(cfgNode.getAttribute('data-ra-increment'), 50);
    var capRaw = cfgNode.getAttribute('data-ra-cap');
    var cap = capRaw === '' || capRaw == null ? Number.MAX_SAFE_INTEGER : toInt(capRaw, Number.MAX_SAFE_INTEGER);
    var shopId = cfgNode.getAttribute('data-ra-shop') || 'shop';
    var dayStr = cfgNode.getAttribute('data-ra-day') || '';
    var hmsStr = cfgNode.getAttribute('data-ra-hms') || '';
    var maxToday = Math.max(cap, base);
    log('config', { resetHour: resetHour, base: base, intervalMin: intervalMin, incPerUpdate: incPerUpdate, maxToday: maxToday, shopId: shopId, dayStr: dayStr, hmsStr: hmsStr });

    // Build Date from store time strings
    function buildStoreDate(day, hms) {
      if (day && hms) {
        var composed = day + 'T' + hms;
        var d = new Date(composed);
        if (!isNaN(d.getTime())) return d;
      }
      return new Date();
    }

    function getResetStart(date) {
      var d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), resetHour, 0, 0, 0);
      if (date.getHours() < resetHour) {
        d.setDate(d.getDate() - 1);
      }
      return d;
    }

    var nowInit = buildStoreDate(dayStr, hmsStr);
    var lastResetStart = getResetStart(nowInit);
    var storeKey = 'ra|' + shopId + '|' + resetHour + '|' + ymd(lastResetStart);
    // Strict fixed-step init: use persisted value if available, otherwise base.
    var persistedRaw = lsGet(storeKey);
    var persisted = toInt(persistedRaw, NaN);
    var initial = !isNaN(persisted) ? clamp(persisted, base, maxToday) : base;

    var current = lastCount != null ? clamp(lastCount, base, maxToday) : initial;
    lastCount = current;
    var lastUpdateMs = nowInit.getTime();

    function maybeReset(now) {
      var rs = getResetStart(now);
      if (rs.getTime() !== lastResetStart.getTime()) {
        lastResetStart = rs;
        storeKey = 'ra|' + shopId + '|' + resetHour + '|' + ymd(lastResetStart);
        current = clamp(base, base, maxToday);
        lastCount = current;
        lsSet(storeKey, current);
        // Reset the update schedule reference time as well
        try { lastUpdateMs = now.getTime(); } catch (e) {}
        log('reset', { at: rs.toISOString ? rs.toISOString() : rs, current: current, key: storeKey });
      }
    }

    function render() {
      countNode.textContent = String(current);
      log('render', { text: countNode.textContent });
      lsSet(storeKey, current);
    }

    function tick() {
      var now = buildStoreDate(dayStr, hmsStr);
      maybeReset(now);
      if (current < maxToday) {
        current = clamp(current + incPerUpdate, base, maxToday);
        log('tick', { inc: incPerUpdate, current: current });
        render();
      }
      lastCount = current;
      lsSet(storeKey, current);
      try { lastUpdateMs = now.getTime(); } catch (e) {}
    }

    // Catch-up strictly by elapsed intervals (no extra increments on rapid tab switches)
    function catchUp() {
      var now = buildStoreDate(dayStr, hmsStr);
      maybeReset(now);
      var intervalMs = Math.max(1, intervalMin * 60 * 1000);
      var nowMs = now.getTime();
      var elapsed = nowMs - lastUpdateMs;
      var ticksDue = Math.floor(elapsed / intervalMs);
      if (ticksDue > 0 && current < maxToday) {
        var incTotal = incPerUpdate * ticksDue;
        current = clamp(current + incTotal, base, maxToday);
        log('catchUp', { ticksDue: ticksDue, incTotal: incTotal, current: current });
        render();
        // Move the schedule forward only by whole intervals
        lastUpdateMs = lastUpdateMs + (ticksDue * intervalMs);
      }
    }

    // Initial render with base
    render();
    activeTimer = setInterval(function () { tick(); }, intervalMin * 60 * 1000);
    currentTick = tick;
    currentCatchUp = catchUp;

    window.addEventListener('beforeunload', function () {
      if (activeTimer) clearInterval(activeTimer);
    });
  }

  function startWhenReady() {
    var banner = document.querySelector('[data-recent-activity]');
    if (banner) { log('init: banner found at ready'); init(banner); }
    log('init: observing DOM for banner changes');
    try {
      var mo = new MutationObserver(function () {
        var el = document.querySelector('[data-recent-activity]');
        if (el && el !== activeBanner) {
          log('init: banner (re)found via observer');
          init(el);
        }
      });
      mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
    } catch (e) {
      log('observer error', e);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    startWhenReady();
  } else {
    document.addEventListener('DOMContentLoaded', startWhenReady);
  }

  // On visibility change, only catch up by elapsed intervals
  document.addEventListener('visibilitychange', function () {
    try { if (typeof currentCatchUp === 'function') currentCatchUp(); } catch (e) {}
  });
})();